<template lang="pug">
	section#header
		picture.img
			img(src="@images/logo/logo-unifael-preta.png")
</template>

<script>
export default {
	name: "section-header"
}
</script>

<style lang="stylus" scoped src="./Header.styl"></style>
